import CollapseExpandText from './CollapseExpandText.component';
export default CollapseExpandText;